import get from "lodash/get";
import React, { useMemo } from "react";
import {
  IAllShortageInvestigation,
  IDay5Investigation,
} from "../models/shortage";
import "./asInvestigationTemplate.css";
import { AS_INVESTIGATION_WIZARD_STEPS } from "../constants";

interface ASInvestigationTemplateProps {
  values?: IAllShortageInvestigation;
  osdNumber: number;
  currentDay?: string;
}

const ASInvestigationTemplate: React.FC<ASInvestigationTemplateProps> = (
  props: ASInvestigationTemplateProps
): JSX.Element => {
  const values = useMemo(() => props.values, [props.values]);
  const getYesNoValue = (key: keyof IAllShortageInvestigation) => {
    if (!values) return;
    return values[key] === "Y" ? "Yes" : "No";
  };
  return (
    <>
      {values && (
        <>
          {props.currentDay === AS_INVESTIGATION_WIZARD_STEPS[0] && (
            <div id="as-in-day1">
              <div style={{ width: "100%", fontFamily: "calibri" }}>
                <div className="temp-title">
                  All Shortage Investigation Day 1{" "}
                  <span className="temp-osd">#{props?.osdNumber}</span>
                </div>
              </div>
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Does the freight show at the destination terminal?
                </div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("showAtDestTerm")}
                  </div>
                  {values.showAtDestTerm !== "Y" && (
                    <div className="temp-word-brack">
                      {values.dateToDestTerm}
                    </div>
                  )}
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Confirm freight is not in the destination terminals OS&D bay
                  or on their Overage report
                </div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("notInDestTerm")}
                  </div>
                  <div className="temp-image-values">
                    {values.notInDestTerm === "Y" && values.notInDestTermSteps}
                  </div>
                </div>
              </div>
              {/* F18 Notes */}
              <div className="temp-cal-width">
                <div className="temp-margin-10">F18 Notes</div>

                <div>
                  <div className="temp-image-values">{values.day1F18Note}</div>
                </div>
              </div>
            </div>
          )}
          {props.currentDay === AS_INVESTIGATION_WIZARD_STEPS[1] && (
            <div id="as-in-day2">
              <div style={{ width: "100%", fontFamily: "calibri" }}>
                <div className="temp-title">
                  All Shortage Investigation Day 2{" "}
                  <span className="temp-osd">#{props?.osdNumber}</span>
                </div>
              </div>
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Confirm the master shows no movement?
                </div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("noMovement")}
                  </div>
                  <br />
                  {values.noMovement === "Y" && (
                    <>
                      <div className="temp-margin-10">
                        Select date of last movement
                      </div>
                      <div className="temp-image-values">
                        {values.dateLastMovement}
                      </div>{" "}
                      <br />
                    </>
                  )}
                  {values.noMovement === "Y" && values.noMovementSteps && (
                    <>
                      <div className="temp-margin-10">Described steps</div>
                      <div className="temp-image-values">
                        {values.noMovementSteps}
                      </div>{" "}
                    </>
                  )}
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Check if a suffix bill or OD400 was cut to move some or all of
                  the freight.
                </div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("suffixBill")}
                  </div>
                  {values.suffixBill === "Y" && (
                    <div className="temp-word-brack">
                      {values.suffixBillSteps}
                    </div>
                  )}
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Check the BOL to confirm completion and no discrepancies?
                </div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("bolCheck")}
                  </div>

                  {values.bolCheck === "Y" && (
                    <div className="temp-word-brack">
                      {values.bolCheckSteps}
                    </div>
                  )}
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">Is there a DR?</div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("drCheck")}
                  </div>
                  {values.drCheck === "Y" && (
                    <>
                      <div>
                        Did you confirm completion and no discrepancies?:
                      </div>{" "}
                      <br />
                      <div className="temp-image-values">
                        {values.drCheckSteps}
                      </div>
                    </>
                  )}
                </div>
              </div>
              {/* F18 Notes */}
              <div className="temp-cal-width">
                <div className="temp-margin-10">F18 Notes</div>

                <div>
                  <div className="temp-image-values">{values.day2F18Note}</div>
                </div>
              </div>
            </div>
          )}
          {props.currentDay === AS_INVESTIGATION_WIZARD_STEPS[2] && (
            <div id="as-in-day3">
              <div style={{ width: "100%", fontFamily: "calibri" }}>
                <div className="temp-title">
                  All Shortage Investigation Day 3{" "}
                  <span className="temp-osd">#{props?.osdNumber}</span>
                </div>
              </div>
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Check the PUM (Pickup manifest) for discrepancies, shipper
                  load and count information, and proper reporting process
                </div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("pumCheck")}
                  </div>
                  {values.pumCheck === "Y" && (
                    <>
                      <div>Pickup Manifest #</div> <br />
                      <div className="temp-image-values">
                        {values.pickupManifest}
                      </div>
                      <br />
                      <br />
                    </>
                  )}

                  {values.pumCheck === "Y" && (
                    <>
                      <div>List any and all discrepancies: </div> <br />
                      <div className="temp-image-values">{values.pumSteps}</div>
                    </>
                  )}
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Was this a shipper load and count?
                </div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("shipperLoad")}
                  </div>
                  {values.shipperLoad === "Y" && (
                    <>
                      <div className="temp-margin-10">
                        Were there any discrepancies? If so, were they properly
                        reported to the shipper?
                      </div>
                      <div className="temp-image-values">
                        {values.discrepancies}
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Check all linehaul manifests – movement and abnormalities.
                </div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("checkLinehaulManifests")}
                  </div>
                  {values.checkLinehaulManifests === "Y" && (
                    <div className="temp-word-brack">
                      {values.linehaulManifests}
                    </div>
                  )}
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Interview the dock worker(s) about movement abnormalities.
                </div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("interviewWorkers")}
                  </div>
                  {values.interviewWorkers === "Y" && (
                    <div className="temp-word-brack">{values.workerSteps}</div>
                  )}
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Call consignee to confirm what was ordered and received (if
                  anything)
                </div>

                <div>
                  <div className="temp-cal-width-y-n"></div>
                  <div>Phone Number: </div> <br />
                  <div className="temp-image-values">
                    {values.consigneePhone}
                  </div>
                  <br />
                  <br />
                  <div>Consignee Name: </div> <br />
                  <div className="temp-image-values">
                    {values.consigneeName}
                  </div>
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Is the consignee still short?
                </div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("consigneeShort")}
                  </div>
                  {values.consigneeShort === "Y" && (
                    <>
                      <div>
                        {" "}
                        What are the item numbers received and still missing?{" "}
                      </div>{" "}
                      <br />
                      <div className="temp-image-values">
                        {values.itemNumbers}
                      </div>
                      <br />
                      <br />
                    </>
                  )}

                  {values.consigneeShort === "Y" && (
                    <>
                      <div> What was ordered and received for each PO? </div>{" "}
                      <br />
                      <div className="temp-image-values">
                        {values.orderReceived}
                      </div>
                      <br />
                      <br />
                    </>
                  )}

                  {values.consigneeShort === "Y" && (
                    <>
                      <div> Was the freight received labeled for them? </div>{" "}
                      <br />
                      <div className="temp-image-values">
                        {values.freightLabeled}
                      </div>
                      <br />
                      <br />
                    </>
                  )}
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Call Shipper to confirm what was shipped, how it was packaged
                  and the value?
                </div>

                <div>
                  <div className="temp-cal-width-y-n"></div>
                  <div> Phone Number: </div> <br />
                  <div className="temp-image-values">{values.shipperPhone}</div>
                  <br />
                  <br />
                  <div> Shipper Name: </div> <br />
                  <div className="temp-image-values">{values.shipperName}</div>
                  <br />
                  <br />
                  <div> What are the details of what shipped? </div> <br />
                  <div className="temp-image-values">
                    {values.shippedDetails}
                  </div>
                  <br />
                  <br />
                  <div>Was this short shipped?</div>
                  <br />
                  <div className="temp-image-values">{values.shortShipped}</div>
                  <br />
                  <br />
                  <div> What is the value of the product? </div> <br />
                  <div className="temp-image-values">{values.productValue}</div>
                  <br />
                  <br />
                  <div>
                    {" "}
                    Were there multiple shipments for the same consignee that
                    day?{" "}
                  </div>{" "}
                  <br />
                  <div className="temp-image-values">
                    {values.multShipments}
                  </div>
                  <br />
                  <br />
                </div>
              </div>
              {/* F18 Notes */}
              <div className="temp-cal-width">
                <div className="temp-margin-10">F18 Notes</div>

                <div>
                  <div className="temp-image-values">{values.day3F18Note}</div>
                </div>
              </div>
            </div>
          )}
          {props.currentDay === AS_INVESTIGATION_WIZARD_STEPS[3] && (
            <div id="as-in-day4">
              <div style={{ width: "100%", fontFamily: "calibri" }}>
                <div className="temp-title">
                  All Shortage Investigation Day 4{" "}
                  <span className="temp-osd">#{props?.osdNumber}</span>
                </div>
              </div>
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Check 78/18 and/or Power BI for any overages (OV, NB, DO) to
                  apply
                </div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("check7818")}
                  </div>
                  <div className="temp-image-values">
                    {values.check7818 === "Y" && values.details7818}
                  </div>
                </div>
              </div>

              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Did this show manifested to the destination terminal (even if
                  NF)?
                </div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("manifested")}
                  </div>
                  {values.manifested === "Y" && (
                    <>
                      <div>Check cameras at DT and report findings</div>
                      <br />
                      <div className="temp-image-values">
                        {values.cameraFindings}
                      </div>
                    </>
                  )}
                </div>
              </div>
              {/* F18 Notes */}
              <div className="temp-cal-width">
                <div className="temp-margin-10">F18 Notes</div>

                <div>
                  <div className="temp-image-values">{values.day4F18Note}</div>
                </div>
              </div>
            </div>
          )}
          {props.currentDay === AS_INVESTIGATION_WIZARD_STEPS[4] && (
            <div id="as-in-day5">
              <div style={{ width: "100%", fontFamily: "calibri" }}>
                <div className="temp-title">
                  All Shortage Investigation Day 5{" "}
                  <span className="temp-osd">#{props?.osdNumber}</span>
                </div>
              </div>
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Contact the terminals that handled the freight to find leads
                  and check cameras if applicable
                </div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("contactTerminals")}
                  </div>

                  {values.contactTerminals === "Y" && (
                    <div>
                      {get(values, "freightTerminalLeadInquiries", []).map(
                        (
                          iDay5Investigation: IDay5Investigation,
                          index: number
                        ) => (
                          <>
                            <div style={{ marginBottom: "10px" }}>
                              <h3 className="header-text mb-0">
                                Investigation details: {index + 1}
                              </h3>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                              <strong>TID:</strong>{" "}
                            </div>
                            <div className="temp-image-values">
                              {iDay5Investigation?.terminal}
                            </div>

                            <div style={{ marginBottom: "10px" }}>
                              <strong>Manifest #:</strong>{" "}
                            </div>
                            <div className="temp-image-values">
                              {iDay5Investigation?.manifest}
                            </div>

                            <div style={{ marginBottom: "10px" }}>
                              <strong>
                                List any discrepancies or abnormalities:
                              </strong>{" "}
                            </div>
                            <div className="temp-image-values">
                              {iDay5Investigation?.discrepancies}
                            </div>
                          </>
                        )
                      )}
                    </div>
                  )}
                </div>
              </div>
              {/* F18 Notes */}
              <div className="temp-cal-width">
                <div className="temp-margin-10">F18 Notes</div>

                <div>
                  <div className="temp-image-values">{values.day5F18Note}</div>
                </div>
              </div>
            </div>
          )}
          {props.currentDay === AS_INVESTIGATION_WIZARD_STEPS[5] && (
            <div id="as-in-day10">
              <div style={{ width: "100%", fontFamily: "calibri" }}>
                <div className="temp-title">
                  All Shortage Investigation Day 10{" "}
                  <span className="temp-osd">#{props?.osdNumber}</span>
                </div>
              </div>
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Follow up on all leads/request from previous days
                </div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("followUp")}
                  </div>
                  {values.followUp === "Y" && (
                    <div className="temp-word-brack">
                      {values.followUpDetails}
                    </div>
                  )}
                </div>
              </div>
              {/* F18 Notes */}
              <div className="temp-cal-width">
                <div className="temp-margin-10">F18 Notes</div>

                <div>
                  <div className="temp-image-values">{values.day10F18Note}</div>
                </div>
              </div>
            </div>
          )}
          {props.currentDay === AS_INVESTIGATION_WIZARD_STEPS[6] && (
            <div id="as-in-day15">
              <div style={{ width: "100%", fontFamily: "calibri" }}>
                <div className="temp-title">
                  All Shortage Investigation Day 15{" "}
                  <span className="temp-osd">#{props?.osdNumber}</span>
                </div>
              </div>
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Check 78/18 and/or Power BI for any overages (OV, NB, DO) to
                  apply
                </div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("check7818_2")}
                  </div>
                  {values.check7818_2 === "Y" && (
                    <div className="temp-word-brack">
                      {values.details7818_2}
                    </div>
                  )}
                </div>

                <div style={{ margin: "20px 0 10px" }}>
                  Is this high value or high quantity?
                </div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("highValue")}
                  </div>
                </div>
              </div>
              {/* F18 Notes */}
              <div className="temp-cal-width">
                <div className="temp-margin-10">F18 Notes</div>

                <div>
                  <div className="temp-image-values">{values.day15F18Note}</div>
                </div>
              </div>{" "}
            </div>
          )}
          {props.currentDay === AS_INVESTIGATION_WIZARD_STEPS[7] && (
            <div id="as-in-day20">
              <div style={{ width: "100%", fontFamily: "calibri" }}>
                <div className="temp-title">
                  All Shortage Investigation Day 20{" "}
                  <span className="temp-osd">#{props?.osdNumber}</span>
                </div>
              </div>
              <div className="temp-cal-width">
                <div className="temp-margin-10">
                  Final re-check of all leads/requests/overages to confirm the
                  freight cannot be located at this time
                </div>

                <div>
                  <div className="temp-cal-width-y-n">
                    {getYesNoValue("finalReCheck")}
                  </div>
                  {values.finalReCheck === "Y" && (
                    <div className="temp-word-brack">
                      {values.detailsOfSearch}
                    </div>
                  )}
                </div>
              </div>
              {/* F18 Notes */}
              <div className="temp-cal-width">
                <div className="temp-margin-10">F18 Notes</div>

                <div>
                  <div className="temp-image-values">{values.day20F18Note}</div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ASInvestigationTemplate;
